import * as Sentry from '@sentry/react';

import { preQualificationApi } from 'prequalificationV2/api/PreQualification/PreQualificationApi';
import {
  NextStepDestination,
  NextStepNavigation,
  resolveNextStepNavigation,
} from 'prequalificationV2/utils/nextStepNavigation';
import { ApplicationType } from 'enums/ApplicationType';

export const getPostLoginNavigation = async (loanType?: ApplicationType): Promise<NextStepNavigation> => {
  try {
    const { step } = await preQualificationApi.getNextStep();

    return resolveNextStepNavigation(step, loanType);
  } catch (error) {
    Sentry.captureException(error, {
      extra: { context: 'Failed to fetch next prequalification step' },
    });

    return { destination: NextStepDestination.Dashboard };
  }
};
